import React from 'react';
import { Form } from 'tea-component';
import { getValidDate } from '@gp/utils/common';

import './index.scss';

interface IPPSCommentContext {
  id: string;
  comment: string;
  pps_update_time: string;
  status: string;
  update_user: string;
}

interface IPPSCommentDetailsProps {
  // text: string,
  // updator: string;
  // updateTime: string;
  data: {
    list: IPPSCommentContext[] | null;
    view_pps: boolean;
  } | null;
}

const PPSCommentDetails: React.FC<IPPSCommentDetailsProps> = (props) => {
  const {
    // text = '',
    // updator = '',
    // updateTime = '',
    data = null,
  } = props;

  /* const updateInfo = useMemo(() => {
    return [updateTime, updator]
      .filter((item) => !!item?.length)
      .join(' ');
  }, [updator, updateTime]); */

  return (
    <Form
      className="font14 dbg-all-projects-pps-comment-details gp-inital-list-style dbg-rich-text-editor-content"
      layout="fixed"
      fixedLabelWidth="94px"
    >
      {/* 最近一条 */}
      {Array.isArray(data?.list) && data?.view_pps && (
        <div className="dbg-all-projects-pps-comment-details-line">
          <Form.Item label="Latest Version" showStatusIcon={false}>
            {getValidDate(data?.list?.[0]?.pps_update_time, 'YYYY-MM-DD HH:mm:ss')}&nbsp;&nbsp;
            {data?.list?.[0]?.update_user || '-'}
          </Form.Item>
          <Form.Item label="Evaluation" showStatusIcon={false}>
            <span dangerouslySetInnerHTML={{ __html: data?.list?.[0]?.comment || '-' }}></span>
          </Form.Item>
        </div>
      )}
      {/* 上一条 */}
      {Array.isArray(data?.list) && data?.list?.[1] && data?.view_pps && (
        <div className="dbg-all-projects-pps-comment-details-line">
          <Form.Item label="Latest Version" showStatusIcon={false}>
            {getValidDate(data?.list?.[1]?.pps_update_time, 'YYYY-MM-DD HH:mm:ss')}&nbsp;&nbsp;
            {data?.list?.[1]?.update_user || '-'}
          </Form.Item>
          <Form.Item label="Evaluation" showStatusIcon={false}>
            <span dangerouslySetInnerHTML={{ __html: data?.list?.[1]?.comment || '-' }}></span>
          </Form.Item>
        </div>
      )}
    </Form>
  );
};

export default React.memo(PPSCommentDetails);
